/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: 'us-east-1',
  aws_appsync_graphqlEndpoint: 'https://lpmi75a7tjginh3e4kmmi5n5ba.appsync-api.us-east-1.amazonaws.com/graphql',
  aws_appsync_region: 'us-east-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_appsync_apiKey: 'da2-5gf7pji2sne2desvncyzxyhjgm',
  aws_cognito_identity_pool_id: 'us-east-1:e10b330c-e473-42ab-a7e4-5c115ef6eca8',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_hhQ564LmM',
  aws_user_pools_web_client_id: '7e3glac46nh7033eer6efiftcc',
  oauth: {
    domain: 'auth-staging.likiee.com',
    scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn: 'https://staging.likiee.com/',
    redirectSignOut: 'https://staging.likiee.com/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_AND_IDENTITY_POOLS',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE', 'APPLE'],
  aws_cognito_signup_attributes: ['NAME'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: ['REQUIRES_LOWERCASE', 'REQUIRES_NUMBERS', 'REQUIRES_SYMBOLS', 'REQUIRES_UPPERCASE'],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_user_files_s3_bucket: 'likiee-main143129-stage',
  aws_user_files_s3_bucket_region: 'us-east-1',
};

export default awsmobile;
